<template>
  <div>
    <v-card-title class="pa-0">
      <h2 class="headline font-weight-bold black--text">
        {{ $t("newsTutorial.newsList") }}
      </h2>
    </v-card-title>
    <v-card-text class="pa-0">
      <slot name="filters"></slot>
    </v-card-text>
    <v-card-text class="pa-0 mt-3">
      <!--<div v-if="isListEmpty">
        <h2 class="font-italic font-weight-light">
          {{ $t("newsTutorial.empty-content") }}
        </h2>
      </div>-->
      <transition-group
        name="slide-fade"
        mode="out-in"
        class="list-container"
        tag="div"
      >
        <div
          class="list-item-wrapper"
          v-for="newsTutorialItem in items"
          :key="newsTutorialItem.id"
        >
          <news-tutorial-list-item
            :newsTutorialItem="newsTutorialItem"
          ></news-tutorial-list-item>
        </div>
      </transition-group>
    </v-card-text>
  </div>
</template>

<script>
import NewsTutorialListItem from "./NewsTutorialListItem";

export default {
  components: {
    "news-tutorial-list-item": NewsTutorialListItem
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    isListEmpty() {
      return this.items.length === 0;
    }
  }
};
</script>

<style scoped>
.list-container {
  min-height: 450px;
}
.list-item-wrapper {
  margin-bottom: 8px;
}

.list-item-wrapper:last-child {
  margin-bottom: 2px;
}
</style>
